
<app-loader *ngIf="showLoading"></app-loader>
<form [formGroup]="loginForm" class="login-container" (ngSubmit)="Login()">
<!-- Main Wrapper -->
<div class="main-wrapper">
    <div class="account-content">
    
      <div class="container">
      
        <!-- Logo -->
        <div class="account-logo">
          <a href="Dashboard"><img src="assets/Images/logo.png" alt="HR Managemet"></a>
        </div>
        <!-- /Logo -->
        
        <div class="account-box">
          <div class="account-wrapper">
            <h3 class="account-title">Login</h3>
            <p class="account-subtitle">Access to our dashboard</p>
            
          
            <div *ngIf="errorHandle" class="help-block">{{errorMessage}}</div>
              <div class="form-group">
                  
                <label>User Name</label>
                <div [ngClass]="{ 'has-error': isSubmitted && formControls.username.errors }">
                  <input type="text" class="form-control" name="name" placeholder="Please enter username" [(ngModel)]="data.username" 
                formControlName="username">
                </div>
               
                  <div *ngIf="isSubmitted && formControls.username.errors" class="help-block">
                      <div *ngIf="formControls.username.errors.required">Username is required</div>
                    </div>
              </div>
              <div class="form-group">
                  
                <div class="row">
                  <div class="col">
                    <label>Password</label>
                  </div>
                  <div class="col-auto">
                    <a routerLink="/forgotpassword">
                      Forgot password?
                    </a>
                  </div>
                </div>
                <div [ngClass]="{ 'has-error': isSubmitted && formControls.password.errors }">
                <input class="form-control" type="password" placeholder="Please enter password" [(ngModel)]="data.password" formControlName="password">
                </div>
                <div *ngIf="isSubmitted && formControls.password.errors" class="help-block">
                    <div *ngIf="formControls.password.errors.required">Password is required</div>
                  </div>
              </div>
              <div class="form-group text-center">
                <button class="btn btn-primary account-btn" type="submit">Login</button>
                
              </div>
              
           
            
          </div>
        </div>
        <div style="clear:both"></div>
      </div>
    </div>
      </div>
<!-- /Main Wrapper --> 
</form>